import * as Yup from 'yup';

Yup.addMethod(Yup.string, 'betterEmail', function validateEmail() {
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return this.matches(emailRegex, 'Invalid Email');
});

Yup.addMethod(Yup.string, 'phoneNumber', function validatePhoneNumber() {
  const phoneRegex =
    /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/;
  return this.matches(phoneRegex, 'Invalid phone number');
});

export default Yup;
